import {Component} from '@angular/core';
import {SliderPage} from '../slider-page/slider-page';

@Component({
  selector: 'performancelevel-page',
  templateUrl: 'performancelevel-page.html',
  styleUrls: ['performancelevel-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class PerformancelevelPage extends SliderPage { }
